module.exports = __webpack_public_path__ + "img/about-b-slide3.26721706.jpg";